import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import routes from './routes'
import VueGtag from "vue-gtag";
import VueSocialSharing from 'vue-social-sharing'
import VueDrift from 'vue-drift'


Vue.use(VueGtag, {
  config: { id: "G-9JLTCYVB0S" }
});


Vue.use(VueRouter);

const router = new VueRouter(
  {
    scrollBehavior(to, from) {

      if (to.path.includes('search') && !from.path.includes('overview')) {
        // Maintain position when changing search

      } else if (to.hash) {
        return {
          selector: to.hash,
          behavior: 'smooth'
        }
       } else {
        return { x: 0, y: 0 };
      }

    },
    routes,
    mode: 'history',
  }
);



// On app load, get the topic area and set as global variable to use through the payload calls
const setupConfig = () => {

  
  const topicPath = window.location.pathname.split('/')[1];
  const whiteLabelTrackers = ['esg', 'china'];

  Vue.prototype.$isBallotpediaTracker = !whiteLabelTrackers.includes(topicPath);

  switch(topicPath) {
    case 'elections':
      Vue.prototype.$topic = 1;
      Vue.prototype.$topicNameFull = 'Election Administration';
      Vue.prototype.$topicPath = 'elections';
      Vue.prototype.$topicNameForTextContent = 'Election';
      Vue.prototype.$whatCountsListID = '3DC725E303A24F8D03D5AC8BEBD48A52';
      Vue.use(VueDrift, {
        appId: 'bxgcu9rra88y',
      });
      break;
    case 'esg':
      Vue.prototype.$topic = 2;
      Vue.prototype.$topicNameFull = 'Environmental, Social, and Governance'
      Vue.prototype.$topicPath = 'esg';
      Vue.prototype.$topicNameForTextContent = 'ESG';
      Vue.prototype.$whatCountsListID = null;
      break;
    case 'admin-state':
      Vue.prototype.$topic = 3;
      Vue.prototype.$topicNameFull = 'Administrative State'
      Vue.prototype.$topicPath = 'admin-state';
      Vue.prototype.$topicNameForTextContent = 'Administrative State';
      Vue.prototype.$whatCountsListID = '3DC725E303A24F8D03D5AC8BEBD48A52'; // If different for Admin State, change here  
      Vue.use(VueDrift, {
        appId: 'bxgcu9rra88y',  // If different for Admin State, change here  
      });
      break;
    default:
      Vue.prototype.$topic = 1;
      Vue.prototype.$topicNameFull = 'Election Administration';
      Vue.prototype.$topicPath = 'elections';
      Vue.prototype.$topicNameForTextContent = 'Election'
      Vue.prototype.$whatCountsListID = '3DC725E303A24F8D03D5AC8BEBD48A52'
      Vue.use(VueDrift, {
        appId: 'bxgcu9rra88y',
      });
  }

}


setupConfig();

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')





router.afterEach(to => {

  // After each route change, set global variables
  // This is because the user may go to a different topic area without reloading the app 

  //setupConfig();

  // Update title after each route change

  let title = to.path.substring(1);
  title = title.charAt(0).toUpperCase() + title.slice(1);
  title = title.replaceAll('-', ' ');

  document.title = `${title}`;
});





Vue.use(VueSocialSharing);